import { __assign } from "tslib";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var requestClose = createAction(actionKey + ".REQUEST_CLOSE", function () { return ({}); });
export var fetchCollections = createAction(actionKey + ".FETCH", function () { return ({}); });
export var initializeDeviation = createAction(actionKey + ".INITIALIZE_DEVIATION", function (deviationId, faveCount, noPreselectedFeatured, ignorePreselectedCollections) { return ({
    deviationId: deviationId,
    faveCount: faveCount,
    noPreselectedFeatured: noPreselectedFeatured,
    ignorePreselectedCollections: ignorePreselectedCollections,
}); });
export var initializeDeviationCollections = function (deviationId, collectionids, faveCount, noPreselectedFeatured, ignorePreselectedCollections) {
    if (noPreselectedFeatured === void 0) { noPreselectedFeatured = false; }
    if (ignorePreselectedCollections === void 0) { ignorePreselectedCollections = false; }
    return initializeDeviationCollectionsCustom(deviationId, {
        collectionids: collectionids,
        faveCount: faveCount,
        noPreselectedFeatured: noPreselectedFeatured,
        ignorePreselectedCollections: ignorePreselectedCollections,
    });
};
export var initializeDeviationCollectionsCustom = createAction(actionKey + ".INITIALIZE_DEVIATION_COLLECTIONS", function (deviationId, options) { return (__assign({ deviationId: deviationId }, options)); });
export var toggleCollection = createAction(actionKey + ".TOGGLE_COLLECTION", function (folderId, deviationId) { return ({ folderId: folderId, deviationId: deviationId }); });
export var undoChanges = createAction(actionKey + ".UNDO", function (deviationId) { return ({ deviationId: deviationId }); });
export var commitCollections = createAction(actionKey + ".COMMIT_COLLECTIONS", function (deviation) { return ({ deviation: deviation, notificationQueue: 'default' }); });
export var commitCollectionsCustom = createAction(actionKey + ".COMMIT_COLLECTIONS", function (deviation, notificationQueue) { return ({
    deviation: deviation,
    notificationQueue: notificationQueue,
}); });
export var commitCollectionsSuccess = createAction(actionKey + ".COMMIT_COLLECTIONS.SUCCESS", function (folderIds, deviationId, entities) { return ({
    folderIds: folderIds,
    deviationId: deviationId,
    entities: entities,
}); });
export var commitCollectionsFail = createAction(actionKey + ".COMMIT_COLLECTIONS.FAIL", function (folderIds, deviationId) { return ({
    folderIds: folderIds,
    deviationId: deviationId,
}); });
export var createCollection = createAction(actionKey + ".CREATE_COLLECTION", function (name, selectDeviationId) { return ({ name: name, selectDeviationId: selectDeviationId }); });
export var createCollectionSuccess = createAction(actionKey + ".CREATE_COLLECTION.SUCCESS", function (folderId, entities) { return ({ folderId: folderId, entities: entities }); });
export var createCollectionFail = createAction(actionKey + ".CREATE_COLLECTION.FAIL", function (name) { return ({ name: name }); });
export var changeFave = createAction(actionKey + ".CHANGE_FAVE", function (deviation, to) { return ({
    deviation: deviation,
    to: to,
    notificationQueue: 'default',
}); });
export var changeFaveCustom = createAction(actionKey + ".CHANGE_FAVE", function (deviation, to, notificationQueue) { return ({
    deviation: deviation,
    to: to,
    notificationQueue: notificationQueue,
}); });
export var changeFaveSuccess = createAction(actionKey + ".CHANGE_FAVE.SUCCESS", function (deviationId, to) { return ({ deviationId: deviationId, to: to }); });
export var changeFaveFail = createAction(actionKey + ".CHANGE_FAVE.FAIL", function (deviationId) { return ({ deviationId: deviationId }); });
export var collectFave = createAction(actionKey + ".COLLECTFAVE", function (deviation, notificationQueue) { return ({
    deviation: deviation,
    notificationQueue: notificationQueue,
}); });
export var setFaveState = createAction(actionKey + ".SET_FAVE", function (deviation, to) { return ({ deviation: deviation, to: to }); });
export var resetJustFaved = createAction(actionKey + ".RESET_JUST_FAVED", function (deviationId) { return ({ deviationId: deviationId }); });
//# sourceMappingURL=actionCreators.js.map